<template>
    <b-modal centered id="modal-advertising" inner-class="advertising-modal" size="lg" title="" hide-header hide-footer>
        <h2 class="text-right">
            <a href="javascript:;" class="" @click="$bvModal.hide('modal-advertising')">
                <font-awesome-icon :icon="['fal', 'times-circle']" size="lg" class="text-white"/>
            </a>
        </h2>
        <div v-if="modal_data.modal_type_id" v-switch="modal_data.modal_type_id">
            <v-advertising-normal v-case="1" :modal_data="modal_data">
            </v-advertising-normal>
            <v-advertising-mobile v-case="2" :modal_data="modal_data">
            </v-advertising-mobile>
            <v-advertising-video v-case="3" :modal_data="modal_data">
            </v-advertising-video>
            <v-advertising-both v-case="4" :modal_data="modal_data">
            </v-advertising-both>
        </div>
    </b-modal>
</template>

<script>
    import AdvertisingNormal from "./advertising-modals/normal";
    import AdvertisingMobile from "./advertising-modals/mobile";
    import AdvertisingVideo from "./advertising-modals/video";
    import AdvertisingBoth from "./advertising-modals/both";

    export default {
        name: 'advertising-modal',
        components: {
            'v-advertising-normal': AdvertisingNormal,
            'v-advertising-mobile': AdvertisingMobile,
            'v-advertising-video': AdvertisingVideo,
            'v-advertising-both': AdvertisingBoth,
        },
        data() {
            return {
                modal_data: {modal_type_id: ""}
            }
        },
        mounted() {
            this.modal()
        },
        methods: {
            modal() {
                this.axios.get("modals").then(result => {
                    if (result.data) {
                        this.modal_data = result.data
                        this.$bvModal.show('modal-advertising');
                    }
                }).catch(() => {

                })
            },
        }
    }
</script>
<style>
    #modal-advertising___BV_modal_outer_ {
        z-index: 1060 !important;
    }

    #modal-advertising___BV_modal_content_ {
        background: none !important;
        border: none !important;
    }
</style>
